// 父容器使用sa-expose:a="{ time: 200 }" a为组别名称, time为滚动节流时间
// 子节点使用sa-dom:a=“value”. a为组别名称，默认default为window滚动；value属性如下：
// 1.saExpose: 曝光时会触发子节点组件的expose事件，saExpose数据会当成参数
// 2.once: 是否曝光一次之后不再监听，默认false，如果为true，节点离开时也不会触发unexpose事件
// 3.globalExpose: 是否全局$emit，统一在App.vue进行监听处理，不然需要在该元素所在组件的父组件进行监听
// 4.fullUnExpose: 是否完全离开才触发unexpose事件，默认false

import { debounce } from '@kk/utils';

const sa = {};
// 需要监控是否在是口内的元素
const caches = {};
// 滚动容器实际的偏移位置，例如被导航栏遮住部分，需要计算进去，目前手动设置
const distance = {};
//曝光检测触发函数，当某事件发生时，比如scroll事件，比如轮播图切换事件，触发该函数，检测命名容器内的元素是否处于视野范围内
// eslint-disable-next-line sonarjs/cognitive-complexity
function scrollHandler(arg, time) {
    if (!time) time = 300;
    return debounce(function () {
        if (!caches[arg]) {
            console.warn(`arg为${arg}的容器下无监听曝光dom`);
            return;
        }
        caches[arg].forEach((item) => {
            const elem = item.el;
            const vm = item.vm;
            // 已曝光，就不在曝光
            if (elem.dataset.once === 'true' && elem.dataset.exposed === 'true') return;
            const rect = elem.getBoundingClientRect();
            // +1防止小数点对比失败,完全进入并且原来处于非曝光状态，触发曝光
            if (
                rect.top + 1 > distance[arg].top &&
                rect.bottom < distance[arg].bottom + 1 &&
                rect.left + 1 > distance[arg].left &&
                rect.right < distance[arg].right + 1
            ) {
                // 离开过的进入，触发expose事件
                if (elem.dataset.exposedIn !== 'true') {
                    vm &&
                        vm.$emit(
                            'expose',
                            elem.dataset.saExpose && JSON.parse(elem.dataset.saExpose)
                        );
                    if (elem.dataset.global === 'true') {
                        window.mixinBus &&
                            window.mixinBus.$emit(
                                'globalExpose',
                                elem.dataset.saExpose && JSON.parse(elem.dataset.saExpose)
                            );
                    }
                    elem.dataset.exposed = true;
                    elem.dataset.exposedIn = true;
                }
            } else {
                // 默认fullUnExpose 为 false的情况下，只要不是完全进入就可以触发，所以走else的肯定都可以触发，直接true
                let condition = true;
                // fullUnExpose 为 true,完全离开才可以触发unexpose
                if (elem.dataset.fullUnExpose === 'true') {
                    condition =
                        rect.bottom < distance[arg].top + 1 ||
                        rect.top + 1 > distance[arg].bottom ||
                        rect.right < distance[arg].left + 1 ||
                        rect.left + 1 > distance[arg].right;
                }
                if (!condition) return;
                // 进入过的离开，触发unexpose事件
                if (elem.dataset.exposedIn === 'true') {
                    vm &&
                        vm.$emit(
                            'unexpose',
                            elem.dataset.saExpose && JSON.parse(elem.dataset.saExpose)
                        );
                    if (elem.dataset.global === 'true') {
                        window.mixinBus &&
                            window.mixinBus.$emit(
                                'globalUnexpose',
                                elem.dataset.saExpose && JSON.parse(elem.dataset.saExpose)
                            );
                    }
                    elem.dataset.exposedIn = false;
                }
            }
        });
    }, time);
}
function datasetHandle(data, el) {
    if (data) {
        el.dataset.saExpose = data.saExpose ? JSON.stringify(data.saExpose) : '';
        el.dataset.once = data.once ? JSON.stringify(data.once) : false;
        el.dataset.global = data.globalExpose ? JSON.stringify(data.globalExpose) : false;
        el.dataset.fullUnExpose = data.fullUnExpose ? 'true' : 'false';
    }
}
let nameCount = Math.floor(Math.random() * 10000);
function getUniqueName(name = '') {
    return name + '_' + nameCount++;
}
sa.install = (Vue) => {
    // 曝光监听
    Vue.directive('sa-expose', {
        bind: function (el, binding) {
            const arg = binding.arg || 'default';
            const value = binding.value || {};
            el.scrollHandler = scrollHandler(arg, value.time);
            if (el.scrollHandler) {
                el.addEventListener('scroll', el.scrollHandler);
            }
        },
        inserted: function (el, binding) {
            const arg = binding.arg || 'default';
            const value = binding.value || {};
            if (arg === 'default') {
                console.warn('v-sa-expose指令参数非法');
                return;
            }
            if (!distance[arg]) distance[arg] = {};
            const clientRect = el.getBoundingClientRect();
            distance[arg].top = value.top || clientRect.top;
            distance[arg].bottom = value.bottom || clientRect.bottom;
            distance[arg].left = value.left || clientRect.left;
            distance[arg].right = value.right || clientRect.right;
        },
        unbind: function (el, binding) {
            const arg = binding.arg || 'default';
            if (arg === 'default') {
                console.warn('v-sa-expose指令参数非法');
                return;
            }
            el.removeEventListener('scroll', el.scrollHandler);
            el.scrollHandler = null;
        },
    });
    // 缓存需要曝光打点的节点，visible:hidden和opaicity=0的元素会被正常报告
    Vue.directive('sa-dom', {
        bind: function (el, binding, vnode) {
            const arg = binding.arg || 'default';
            const data = binding.value;
            datasetHandle(data, el);
            if (!caches[arg]) caches[arg] = [];
            caches[arg].push({
                el,
                vm: vnode.componentInstance || vnode.context,
            });
        },
        update: function (el, binding, vnode) {
            const arg = binding.arg || 'default';
            const data = binding.value;
            datasetHandle(data, el);
            // 更新节点
            if (caches[arg]) {
                const index = (caches[arg] || []).findIndex((item) => item.el === el);
                if (index !== -1) {
                    caches[arg][index].vm = vnode.componentInstance || vnode.context;
                } else {
                    caches[arg].push({
                        el,
                        vm: vnode.componentInstance || vnode.context,
                    });
                }
            }
        },
        unbind: function (el, binding) {
            const arg = binding.arg || 'default';
            const index = (caches[arg] || []).findIndex((item) => item.el === el);
            index !== -1 && caches[arg].splice(index, 1);
        },
    });
};
let windowScrollHandler;
sa.registerWindowScrollHandler = function (param = {}) {
    // 防止忘记清除导致绑定太多scroll事件, 手动帮你清一下
    if (windowScrollHandler) {
        window.removeEventListener('scroll', windowScrollHandler);
    }
    sa.addDistance(param);

    windowScrollHandler = scrollHandler(param.name, param.time);
    window.addEventListener('scroll', windowScrollHandler);
};
sa.unregisterWindowScrollHandler = function () {
    window.removeEventListener('scroll', windowScrollHandler);
    windowScrollHandler = null;
};
sa.addDistance = function (param) {
    if (!distance[param.name]) {
        distance[param.name] = {};
    }
    distance[param.name].top = param.top || 0;
    distance[param.name].bottom = param.bottom || window.innerHeight;
    distance[param.name].left = param.left || 0;
    distance[param.name].right = param.right || window.innerWidth;
};
export default sa;
export { getUniqueName, scrollHandler as Handler };
